module.exports = __webpack_public_path__ + "static/media/portfolio-5.170a44fb.jpg";